export enum ContractAcceptationType {
    Signature = 1,
    Payment = 2,
    DigitalSignature = 3
}